import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import parentStyles from '../../../styles.module.scss'
import { useTranslation } from 'react-i18next'
import Avatar from 'srcReact/components/common2/Avatar'
import Button from 'srcReact/components/common2/Button'
import ModalWithPost from '../../common/ModalWithPost'
import { getMentionFormat } from 'srcReact/components/common2/RichTextEditor/util'
import { useDispatch } from 'react-redux'
import { groupActions } from 'srcReact/GroupPage'
import { formatNames } from 'srcReact/helpers/utils'

function Celebrate({ celebrateData, groupId }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [users, setUsers] = useState([])
  const [eventData, setEventData] = useState(null)

  useEffect(() => {
    if (celebrateData?.length > 0) {
      const data = celebrateData.filter((x) => x.data_type === 'birthday')
      if (data?.length > 0) {
        setUsers(data.map((user) => user.user_info))
        setEventData(null)
      } else if (celebrateData[0].entity_type === 'event_to_celebrate') {
        setEventData(celebrateData[0].event)
        setUsers([])
      }
    }
  }, [celebrateData])

  const openModal = () => {
    setIsModalOpen(true)
  }
  const closeModal = () => {
    setIsModalOpen(false)
  }
  const tags = () =>
    users
      .map((user) => {
        return getMentionFormat(user.id, user.firstname)
      })
      .join(', ')

  const handlePost = (message) => {
    dispatch(groupActions.addComment(groupId, message, closeModal))
  }

  return (
    <div className={`${parentStyles.card} ${styles.celebrate}`}>
      <h3 className={styles.title}>{t('dashboard.oneThingToCelebrate.title')}</h3>
      {users.length > 0 ? (
        <div className={styles.eventDetails}>
          <div className={styles.userAvatars}>
            {users.map((user) => {
              const { id, firstname, lastname, profile_picture_data, with_expertise_group } = user

              return (
                <Avatar
                  userId={id}
                  firstname={firstname}
                  lastname={lastname}
                  profilePicture={profile_picture_data?.profile_picture}
                  imgWrapperSize='medium'
                  mimeType={profile_picture_data?.mime_type}
                  originalTag={profile_picture_data?.original_tag}
                  isOriginal={profile_picture_data?.is_original}
                  withExpertiseGroup={with_expertise_group}
                />
              )
            })}
          </div>

          <div className={styles.eventDetails}>
            <h5 className={styles.title}>
              {t(`dashboard.oneThingToCelebrate.birthdayToday`, {
                names: formatNames(users, false, t)
              })}
            </h5>
            <Button
              customStyle={styles.btnPost}
              style='transparent'
              size='large'
              text={t('dashboard.oneThingToCelebrate.btn')}
              handleClick={openModal}
            />
          </div>
        </div>
      ) : eventData ? (
        <div className={`${styles.eventDetails} ${styles.specialEventDetails}`}>
          {eventData && <div className={styles.emoji}>&#127881;</div>}
          <h5 className={`${styles.title}`}>{eventData.text}</h5>
          <Button
            customStyle={styles.btnPost}
            style='transparent'
            size='large'
            text={users.length > 0 ? t('dashboard.oneThingToCelebrate.btn') : t('global.writePost')}
            handleClick={openModal}
          />
        </div>
      ) : null}

      {isModalOpen && (
        <ModalWithPost
          objectType={'group'}
          objectId={groupId}
          isOpen={isModalOpen}
          users={users}
          title={t('postMessage.title')}
          subTitle={
            users.length > 0 ? t('postMessage.subTitle', { count: users.length }) : t('postMessage.subTitleEvent')
          }
          handleCancel={closeModal}
          handleConfirm={handlePost}
          labelText={users.length > 0 ? t('postMessage.congMessage') : t('postMessage.celebrateMessage')}
          primaryBtnText={t('global.post')}
          secondaryBtnText={t('global.cancel')}
          defaultMessage={
            users.length > 0 ? t('postMessage.message', { tag: tags() }) : eventData ? eventData.post : ''
          }
          isMessageRequied={true}
        />
      )}
    </div>
  )
}

export default Celebrate
